'use strict';

class Billing {
  constructor(userService, billingService) {
    this.userService = userService;
    this.billingService = billingService;
  }

  $onInit() {
    this.salesLedger = {};
    this.unpaid = {};
    this.all = {};
    this.vippsOrders = {};
    this.features = [];

    this.userService.get()
      .then((resp) => {
        this.originatorNo = resp.data.originatorId;
        this.features = resp.data.features;
      });

    this.billingService.getUnpaidInvoices()
      .then((resp) => {
        this.unpaid = resp.data;
      });

    this.billingService.getAllInvoices()
      .then((resp) => {
        this.all = resp.data;
      });

    this.getVippsOrders();

    this.billingService.getSalesLedger()
      .then((resp) => {
        this.salesLedger = resp.data;
      });
  }

  getVippsOrders() {
    this.billingService.getVippsOrders()
      .then((resp) => {
        this.vippsOrders = resp.data;
      });
  }
}

Billing.$inject = ['userService', 'billingService'];

const billing = {
  controller: Billing,
  template: `
    <section ng-show="$ctrl.unpaid.paymentDetails != null">
      <billing-table show-invoices="true" number="'0'" title="'Ubetalte regninger for bruk av SendRegning'" items="$ctrl.unpaid.items" summary="$ctrl.unpaid.summary"></billing-table>

      <h3 class="subheader">Betalingsdetaljer</h3>
      <ul class="no-bullet">
        <li ng-if="$ctrl.unpaid.paymentDetails.balance != 0"><b>Betalt p&aring; andre fakturaer:</b> {{ $ctrl.unpaid.paymentDetails.balance | crowns }}</li>
        <li><b>&Aring; betale:</b> {{ $ctrl.unpaid.paymentDetails.total | crowns }}</li>
        <li><b>KID:</b> {{ $ctrl.unpaid.paymentDetails.kid }}</li>
        <li><b>Konto:</b> {{ $ctrl.unpaid.paymentDetails.accountNumber | accountNumberFormat }}</li>
      </ul>

    <claim-payment get-vipps-orders="$ctrl.getVippsOrders()" />

    </section>

    <button class="button secondary" ng-show="$ctrl.all.items.length" ng-click="showAll = true; showSl = false; showVipps = false">Se alle regninger</button>
    <button class="button secondary" ng-show="$ctrl.salesLedger.items.length" ng-click="showAll = false; showSl = true; showVipps = false">Se kontoutskrift</button>
    <button class="button secondary" ng-show="$ctrl.vippsOrders.length" ng-click="showAll = false; showSl = false; showVipps = true">Se Vipps betalinger</button>

    <billing-table show-invoices="true" number="'1'" ng-show="showAll" title="'Regninger for bruk av SendRegning'" items="$ctrl.all.items" summary="$ctrl.all.summary"></billing-table>
    <billing-sales-ledger ng-show="showSl" items="$ctrl.salesLedger.items" total="$ctrl.salesLedger.total"></billing-sales-ledger>

    <div ng-show="showVipps">
      <table>
        <thead>
          <tr>
            <th>Regning</th>
            <th>Dato</th>
            <th>Beløp</th>
            <th>OrdreId</th>
            <th>Mobilnummber</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.vippsOrders" ng-switch="item.status">
            <td>
              <a href="{{ item.download }}">{{ item.invoiceNo }}</a>
            </td>
            <td>{{ item.createTs }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.vippsOrderId }}</td>
            <td>{{ item.mobile }}</td>
            <td ng-switch-when="CAPTURED" class="center-align"><span data-balloon="{{ item.status }}"><i class="fa fa-check" style="color: #0f4b1c;"></i></span></td>
            <td ng-switch-default class="center-align"><span data-balloon="{{ item.status }}"><i class="fa fa-times" style="color: #970b0e;"></i></span></td>

          </tr>
        </tbody>
      </table>
    </div>

    <div ng-hide="$ctrl.all.items.length" class="alert-box secondary">Vi har ikke sendt deg noen regninger enn&aring;.</div>
  `
};

angular
  .module('SendRegning')
  .component('billing', billing)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/utskrift', {
        title: 'Kontoutskrift',
        template: '<billing />',
        secure: true
      });
  });
